<template>
  <div class="inputSearchComp">
    <lk-dropdown trigger="custom" :visible="!!(visible&&data.length)" @on-click="onDropDownclick" ref="dropdown"
      :placement='placement' style="width: 100%" :class="{'loading':loading}">
      <lk-input :suffix="'ios-search'" :placeholder='placeHolder' @on-change="onInputChange"
        v-model="value" ref='search' @input="handleInput" @on-blur='inputBlur' @on-keydown='handleSearchKey'
        @on-focus="onInputChange" :maxlength='maxlength' :disabled='inputDisabled'>
      </lk-input>
      <lk-dropdown-menu slot="list" class="searchList" :style="{'max-height':maxHeight}">
        <lk-dropdown-item disabled name='title' v-if="titleList.length">
          <span class="options">
            <span v-for="(item,index) in columns" :key="index" :style='"width:"+item.width'>{{item.title}}</span>
          </span>
        </lk-dropdown-item>
        <lk-dropdown-item  v-for="(item, index) in data" :key="index" :name='index'
          :selected='index===selectedIndex&&!item.disabled'
          :disabled='item.disabled'
          >
          <span class="options">
            <span v-for="(colItem,colIndex) in columns" :key="colIndex" :style='"width:"+colItem.width'>
              <lk-tooltip :content='item[colItem.key]'  placement="bottom-start"  max-width="200" :disabled='!toolTipSq[index][colItem.key]'>
                  <span :id="'row'+index+'col'+colItem.key" :style='"width:"+colItem.width' class="textOver" @mouseenter="handleTooltipIn(index,colItem.key)" @mouseleave="handleTooltipOut(index,colIndex.key)"> {{item[colItem.key]}}</span>
              </lk-tooltip>
   <!-- <template v-if="column.tooltip">
                <Tooltip transfer :content="row[column.key]" :theme="tableRoot.tooltipTheme" :disabled="!showTooltip" :max-width="300" class="ivu-table-cell-tooltip">
                    <span ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ row[column.key] }}</span>
                </Tooltip>
            </template>
            <span v-else>{{row[column.key]}}</span> -->
            </span>
          </span>

        </lk-dropdown-item>
      </lk-dropdown-menu>
    </lk-dropdown>
  </div>
</template>
<script>
// import hotkeys from 'hotkeys-js';
// import sale from '../../services/sale';
// import utils from '../libs/utils';

export default {
  name: 'inputSearch',
  props: {
    inputDisabled: {
      type: Boolean,
      default: false,
    },
    autoFocus: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Array, Object],
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],

    },
    placement: {
      type: String,
      default: 'bottom-start',
    },
    placeHolder: {
      type: String,
      default: '商品编码、助记码、通用名称',
    },
    toolTip: {
      type: Boolean,
      default: true,
    },
    maxLines: {
      type: Number,
      default: 5,
    },
    maxWidth: {
      type: Number,
      // default: 500,
    },
    val: {},
    reset: {// 选择清空
      type: Boolean,
      default: true,
    },
    maxlength: {
      type: Number,
      default: 40
    }
  },
  model: {
    prop: 'val',
    event: 'change',
  },
  computed: {
    maxHeight() {
      return `${this.maxLines * 35}px`;
    },
    titleList() {
      const res = [];
      this.columns.forEach((item) => {
        res.push(item.title);
      });
      return res;
    },

  },
  watch: {
    val() {
      this.value = this.val;
    },
    data: {
      handler() {
        this.toolTipSq = [];
        this.data.forEach(() => {
          const obj = {};
          this.columns.forEach((col) => {
            obj[col.key] = false;
          });
          this.toolTipSq.push(obj);
        });
      },
    },
  },
  data() {
    return {
      // hasTitle: true,
      // columns: [

      toolTipSq: [],
      // ],
      value: '',
      visible: false,
      selectLoading: false,
      selectedIndex: 0,
      options: [],
      timer: null,
      // toolTipSq: [],
    };
  },
  methods: {
    judgeWidth(index, width) {
      const el = document.getElementById(`copy${index}`);
      // console.dir(el);
      return this.visible && el && el.offsetWidth < width.replace('px', '').replace('%', '');
    },
    handleInput() {
      this.$emit('change', this.value);
    },
    onInputChange() {
      clearTimeout(this.timer);
      this.timer = setTimeout(this.getData, 500);
    },
    getData() {
      if (this.value) {
        this.$store.commit('setDisableLoading', true);
        this.$emit('getData', this.value);
        this.visible = true;
      } else {
        this.visible = false;
      }
    },
    handleTooltipIn(row, col) {
      const $content = document.querySelector(`#row${row}col${col}`);
      this.toolTipSq[row][col] = $content.scrollWidth > $content.offsetWidth;
    },
    handleTooltipOut(row, col) {
      this.toolTipSq[row][col] = false;
    },
    // handleClick(){}
    onDropDownclick(name) {
      if (this.selectLoading || name === 'title') {
        this.selectLoading = false;
        this.visible = false;
        this.$nextTick(() => {
          this.$refs.dropdown.currentVisible = false; // 规避iview组件不能驱动内部参数问题
        });
      } else {
        this.visible = true;
        this.selectLoading = true;
        if (!Number.isNaN(name)) {
          this.selectedIndex = name;
          this.selected();
          this.$nextTick(() => {
            this.visible = false;
          });
        }
        setTimeout(() => {
          this.selectLoading = false;
        }, 500);
      }
    },
    inputBlur() {
      this.$nextTick(() => {
        this.visible = false;
        this.$emit('on-blur', this.value);
      });
    },
    onKeydown() {
      // console.log(e);


    },
    focus() {
      this.$refs.search.focus();
    },
    selected() {
      // if (this.options[this.selectedIndex].disabled) {
      //   return;
      // }
      if (this.data[this.selectedIndex].disabled) {
        return;
      }
      this.visible = false;
      this.reset && (this.value = '');
      this.$emit('selected', this.data[this.selectedIndex]);
    },


    handleSearchKey(e) {
      console.log(e);

      if (this.visible) {
        switch (e.key) {
          case 'ArrowDown':
            (this.selectedIndex < this.data.length - 1) && this.selectedIndex++;
            break;
          case 'ArrowUp': (this.selectedIndex > 0) && this.selectedIndex--;
            break;
          case 'Enter': this.selected(); this.$emit('on-keydown', e);
            break;
          default: break;
        }
      }
    },

  },
  mounted() {
    if (this.autoFocus) {
      this.$nextTick(() => {
        this.$refs.search.focus();


        const el = this.$refs.dropdown.$el;
        const target = el.querySelector('.ivu-select-dropdown');
        // console.log(target[0]);
        // console.log(target);
        // console.dir(target);
        // let width = 0;
        // this.columns.forEach((item) => {
        //   width += item.width.replace('px', '').replace('%', '') * 1;
        // });
        // width += (this.columns.length - 1) * 36 + 4;
        // console.log(width);

        target.style.maxWidth = this.maxWidth ? `${this.maxWidth}px` : null;
      });
    }
    // this.value = this.val;
  },
};
</script>
<style lang="less" scoped>
// .inputSearch{
// // position: relative;
//   .loading{
//     // position: absolute;
//     // right: 0px;
//     float: right;

// }

// }
.searchList{
  // max-height: 300px;
  overflow: auto;

}
.selected{
  background: #f8f8f8
}
// .textOver
.options{
  // width: auto;
  display: flex;
  align-items: center;
  font-size: 12px;

  >span{
    // width: 15%;
  flex-shrink: 0;
    box-sizing:content-box;
    text-align: left;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 16px

  }
  >span:last-child{
    padding-right: 0

  }
        >span:nth-child(1){
          padding-left: 0;
          // width: 110px
        }
  // >span:nth-child(2){
  //   width: 98px
  // }
  // >span:nth-child(3){
  //   width: 48px
  // }
  // >span:nth-child(4){
  //   width: 82px
  // }
  // >span:nth-child(5){
  //   width: 72px
  // }
  // >span:nth-child(6){
  //   width: 72px
  // }
  // >span:nth-child(7){
  //   width: 48px
  // }
  // >span:nth-child(8){
  //   width: 48px
  // }
  .textOver{
    width: 100%;
    text-align: left;
    // word-wrap: ;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
